import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { SubstanceDTO } from '@scip/api';
import { ProductTypeEnum, translationKeys } from '../../../../../core';
import { EnumsService } from '../../../../../services';

@Component({
  selector: 'scip-substance-form',
  templateUrl: './substance-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubstanceFormComponent {
  @Input() set substance(val: SubstanceDTO) {
    this.setFormValue(val);
  }

  get vdaMaterialCategories(): AbstractControl {
    return this.substanceForm.get('vdaMaterialCategories');
  }

  get vdaMixtureCategories(): AbstractControl {
    return this.substanceForm.get('vdaMixtureCategories');
  }

  substanceForm: FormGroup = this.fb.group({
    productType: [ProductTypeEnum.SUBSTANCE],
    name: [''],
    casNumber: [''],
    vdaMaterialCategories: [''],
    vdaMixtureCategories: [''],
    concentrationRange: ['']
  });

  displayConcentrationRange: boolean;

  readonly translationKeys: typeof translationKeys = translationKeys;

  private readonly enumeratedValues = ['vdaMaterialCategories', 'vdaMixtureCategories'];

  constructor(private fb: FormBuilder, private enumService: EnumsService) {}

  private setFormValue(substance: SubstanceDTO): void {
    this.displayConcentrationRange = substance.displayConcentrationRange;
    this.substanceForm.disable();
    const formValue = Object.keys(substance).reduce((prev, curr) => {
      if (this.enumeratedValues.includes(curr)) {
        return {
          ...prev,
          [curr]: this.enumService.getCategoryName(substance[curr])
        };
      }
      return {
        ...prev,
        [curr]: substance[curr]
      };
    }, {});

    this.substanceForm.reset({ productType: ProductTypeEnum.SUBSTANCE, ...formValue });
  }
}
